import { render } from "./FloorItem.vue?vue&type=template&id=254da446&scoped=true"
import script from "./FloorItem.vue?vue&type=script&lang=js"
export * from "./FloorItem.vue?vue&type=script&lang=js"

import "./FloorItem.vue?vue&type=style&index=0&id=254da446&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Тестовое TrueConf\\true_conf\\elevator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254da446"]])

export default __exports__